<template lang="html">
  <div class="gallery-image-container col-6 col-sm-6 col-md-3 py-3">
    <div class="gallery-image-loading d-flex">
      <div class="spinner-border text-secondary m-auto"></div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import imageBlobReduce from 'image-blob-reduce'

export default {
  props: {
    file: File,
    order: Number
  },

  computed: {
    imagesMaxSize: () => store.state.sell.imagesMaxSize
  },

  methods: {
    async convertHeicToJpeg (file) {
      try {
        console.log('Converting HEIC file using heic-to...')
        const { heicTo } = await import('heic-to')

        const jpegBlob = await heicTo({
          blob: file,
          type: 'image/jpeg',
          quality: 0.85
        })

        console.log('Conversion successful, created blob:', { size: jpegBlob.size, type: jpegBlob.type })
        return new File([jpegBlob], file.name.replace(/\.[^/.]+$/, ".jpg"), { type: 'image/jpeg' })
      } catch (error) {
        console.error('HEIC conversion error:', error)
        throw error
      }
    },

    async uploadImage () {
      const reduce = new imageBlobReduce()

      let file = this.file
      const order = this.order

      console.log('uploadImage called with file:', { name: file.name, type: file.type, size: file.size })

      // Check if file is HEIC/HEIF and convert
      if (file.type === 'image/heif' || file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic')) {
        try {
          console.log('Detected HEIC file, attempting conversion...')
          file = await this.convertHeicToJpeg(file)
          console.log('Conversion successful, new file:', { name: file.name, type: file.type, size: file.size })
        } catch (error) {
          console.error('HEIC conversion failed:', error)
          this.$emit('errorInUpload', file.name)
          return
        }
      }

      reduce.toBlob(file, { max: this.imagesMaxSize })
        .then(blob => {
          file = new File([blob], file.name, { type: file.type })

          store.dispatch('sell/uploadImage', { file, order })
            .then(() => { this.$emit('imageUploaded', order) })
            .catch(() => { this.$emit('errorInUpload', file.name) })
        })
        .catch(error => {
          console.error('ImageBlobReduce error:', error)
          console.error('File details - name:', file.name, 'type:', file.type, 'size:', file.size)
          this.$emit('errorInUpload', file.name)
        })
    }
  },

  created () {
    this.uploadImage()
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../scss/colors';

  .gallery-image {
    &-container {
      /* width: 100px; */
      height: 150px;
      width: 150px;
      display: inline-block;
    }

    &-loading {
      height: 100%;
      background-color: $gray-200;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/gallery/GalleryImageLoading.vue